import { Link } from "react-router-dom";
import { Header } from "@/components/Header";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="max-w-3xl mx-auto px-5 sm:px-8 py-16" data-testid="payment-cancel">
        <h1 className="font-display font-bold text-3xl tracking-tight">Pagamento cancelado</h1>
        <p className="mt-2 text-zinc-600">Suas fotos continuam no carrinho.</p>
        <Link to="/carrinho" data-testid="back-to-cart-link" className="mt-6 inline-flex h-12 px-6 items-center rounded-md bg-[#0055FF] text-white font-semibold">Voltar ao carrinho</Link>
      </main>
    </div>
  );
}
